import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import EntityListRowForm from "../../../../components/Entities/EntityListRowForm";
import * as schema from '../../../../api/schema';
import EntitiesLoader from "../../../../components/Entities/EntitiesLoader/EntitiesLoader";
import {requireToHighlightFeatures} from "../../../../redux/map/map-reducer";
import mapApi from "../../../../api/mapApi";
import {EntityServiceName} from "../../../../api/enums/enums";
import {isErrorResponse} from "../../../../utils/utils";
import {FeatureState} from "../../../../redux/map/types";
import {useTypedSelector} from "../../../../redux/Hooks/storeSelectors";
import {selectMapLayerIdByEntityName} from "../../../../redux/selectors/selectors";
import {useDispatch} from "react-redux";


const getUrlFunc = ({id}: schema.definitions['entities_replancity_RoadInfrastructureSegment']) => `./${id}/edit`

const RoadSegments = () => {
    const roadEntityName = 'replancity_RoadInfrastructureRoadName';
    const roadSegmentEntityName = 'replancity_RoadInfrastructureSegment';
    const serviceName = 'replancity_RoadInfrastructureService'
    const {roadId} = useParams<any>();
    const segmentsLayerId = useTypedSelector((state) => selectMapLayerIdByEntityName(state, roadSegmentEntityName));
    const dispatch = useDispatch();

    useEffect(() => {
        void (async function () {
            dispatch(requireToHighlightFeatures({
                featureProperties: []
            }));

            const abortController = new AbortController();
            const resp = await mapApi.getListRelatedFeatures({
                    sourceId: roadId!,
                    sourceEntityType: roadEntityName,
                    targetEntityType: roadSegmentEntityName
                },
                EntityServiceName.ROAD_INFRASTRUCTURE,
                abortController.signal);

            if (!isErrorResponse(resp)) {
                const {relatedFeatures} = resp;

                const featureProperties = relatedFeatures.map(id => ({
                    id,
                    featureStateId: id,
                    layerId: segmentsLayerId,
                    entityName: roadSegmentEntityName,
                    stateProperty: FeatureState.HIGHLIGHTED
                }));

                dispatch(requireToHighlightFeatures({
                    featureProperties
                }));
            }
        }());
    }, [roadId, roadSegmentEntityName, segmentsLayerId]);

    return (
        <EntitiesLoader
            entityName={roadSegmentEntityName}
            layerEntityName={roadSegmentEntityName}
            serviceName={serviceName}
            parentId={roadId}
            form={EntityListRowForm}
            getUrlFunc={getUrlFunc}
        />
    )
}

export default RoadSegments;